import { RetailerSnapshot } from 'pages/qa-spec/components/qa-prod-spec/snapshot/RetailerSnapshot';

import { useGetSnapshotQaClaims } from 'pages/qa-spec/components/qa-claims/hooks';

export const QaClaimsSnapshot = ({
  qaSpecType,
  productId,
  isToggleSnapshot,
  ...props
}) => {
  const { isLoading: isLoadingSnapshotQaClaims, isSuccess } =
    useGetSnapshotQaClaims({
      enabled: !!productId && isToggleSnapshot,
      productId,
      productType: qaSpecType,
    });

  if (isLoadingSnapshotQaClaims) {
    return <>{props?.children}</>;
  }

  if (isSuccess && isToggleSnapshot) {
    return <RetailerSnapshot {...props} />;
  }

  return <>{props?.children}</>;
};